export default __webpack_public_path__ + "static/c5-90a48205cf93cb4a219c8afe9201ec15.jpg";